import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { getAccessToken } from "../../api/getAccessToken";
import {
  buildSportsbookSummaryParams,
  parseSportsbookAnalyticsSummaryResponse,
} from "./sportsbookAnalyticsSummaryMapper";
import { SPORTSBOOK_ANALYTICS_PARAMS_SERIALIZER } from "./sportsbookAnalyticsFilterParams";
import type {
  SportsbookAnalyticsSummaryQueryParams,
  SportsbookAnalyticsSummaryResult,
} from "./sportsbookAnalyticsSummaryTypes";

/**
 * Fetches one page of the paginated sportsbook analytics summary.
 */
export async function fetchSportsbookAnalyticsSummary(
  args: SportsbookAnalyticsSummaryQueryParams,
): Promise<SportsbookAnalyticsSummaryResult> {
  const { params, wasClamped } = buildSportsbookSummaryParams(args);

  const instance = createPrivateAdminPanelInstance(getAccessToken());
  const response = await instance.get(
    API_ROUTES.GET_SPORTSBOOK_ANALYTICS_SUMMARY,
    {
      params,
      paramsSerializer: SPORTSBOOK_ANALYTICS_PARAMS_SERIALIZER,
    },
  );
  const parsed = parseSportsbookAnalyticsSummaryResponse(response?.data);
  return { ...parsed, wasRangeClamped: wasClamped };
}
